export default "__VITE_ASSET__BlKNpNpb__"